// src/helpers/fetchAndSetCompetition.js  
import { fetchSelectedCompetition } from '../api/selectedCompetition';
import { useSettings } from '../contexts/settingsContext';

export const fetchAndSetCompetition = async (dispatch) => {
    const selectedCompetition = await fetchSelectedCompetition(); // No token needed as it's in cookies  
    if (selectedCompetition) {
        dispatch({ type: 'UPDATE_COMPETITION', payload: selectedCompetition.selected_competition });
    }
};  
